import React from 'react'
import { Badge, Alert } from 'react-bootstrap'

export const DocumentLabelStatus = ({ file }) => {
   return (
     <>
      {
        file && (
          file.aceptado == null 
          ? <Badge variant="primary">En espera</Badge> 
          : file.aceptado && file.pendiente
            ? <Badge variant="warning">Autorizado/Pendiente</Badge>
            : file.aceptado
              ? <Badge variant="success">Autorizado</Badge>
              : <>
                  <Badge variant="danger">Rechazado</Badge>
                  <Alert variant="danger" className='mt-1'>
                  <h5><strong> Rechazado </strong></h5>
                    { file.observaciones }
                  </Alert>
                </>
        )
      }
     </>
   )
}